<template>
  <v-flex xs12 sm12 lg10 offset-lg1 xl8 offset-xl2>
    <v-list two-line>
      <template v-for="(post, index) in posts">
        <v-list-tile
          :key="post.title"
          :to="{ name: 'post', params: { slug: post.slug } }"
          avatar
          ripple
          class="py-3 elevation-5"
        >
          <v-list-tile-avatar :size="60" class="hidden-xs-only">
            <img
              :src="
                post.media[0].thumb_url ||
                  require('../assets/avatars/default.png')
              "
              alt="Post image"
            />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title> {{ post.title }}</v-list-tile-title>
            <v-list-tile-sub-title class="text--primary">
              {{ post.subtitle }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-list-tile-action-text class="px-1">
              <app-date
                :timestamp="new Date(post.published_on).getTime() / 1000"
              ></app-date>
            </v-list-tile-action-text>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider v-if="index + 1 < posts.length" :key="index"></v-divider>
      </template>
    </v-list>
  </v-flex>
</template>

<script>
import AppDate from './AppDate';

export default {
  name: 'PostList',
  metaInfo: {
    title: 'Blog Post',
  },
  components: {
    AppDate,
  },
  props: {
    posts: {
      required: true,
      type: Array,
    },
  },
  computed: {
    publishDate(date) {
      if (date === null) {
        return;
      }
      return new date(date).getTime() / 1000;
    },
  },
};
</script>

<style scoped>
.v-list__tile__avatar {
  margin-top: 0;
  margin-right: 8px;
}
</style>
